<template>
    <form method="post" @submit.prevent="onSubmit">
        <div class="form-block--main">
            <div class="form__row">
                <div class="form__item form__item--status">
                    <status-autocomplete ref="status" @change="onChange" v-model="$v.form.statusId.$model"
                                         length-type="w--l"/>
                </div>

                <div class="form__item">
                    <form-input label="Označení jednotky" placeholder="Vložte označení jednotky" @change="onChange"
                                :v="$v"
                                name="form.designation" v-model="$v.form.designation.$model" length-type="w--xs"/>
                </div>

                <div class="form__item form__item--active-unit">
                    <form-checkbox label="Aktivní" name="active" @change="onChange" :v="$v"
                                   v-model="$v.form.active.$model"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__item">
                    <form-input label="Cena s DPH" :v="$v" name="form.priceVat" @change="onChange"
                                v-model="$v.form.priceVat.$model" length-type="w--xs" suffix="Kč"/>
                </div>

                <div class="form__item">
                    <form-input label="Textová alternativa ceny" :v="$v" name="form.priceAlternative" @change="onChange"
                                v-model="$v.form.priceAlternative.$model" length-type="w--l"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__item">
                    <form-input label="Doplňující informace k ceně" :v="$v" name="form.priceDescription"
                                @change="onChange"
                                v-model="$v.form.priceDescription.$model" length-type="w--xxl"/>
                </div>
            </div>
            <template v-if="isBroker">
                <div class="form__row">
                    <div class="form__item">
                        <form-select label="Typ" :v="$v" name="form.proposalType" @change="onChange"
                                     v-model="$v.form.proposalType.$model"
                                     :options="[{id: 'SELL', name: 'Prodej'}, {id: 'RENT', name: 'Pronájem'}]"/>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__item">
                        <form-input label="Název" :v="$v" name="form.name"
                                    @change="onChange"
                                    v-model="$v.form.name.$model" length-type="w--xxl"/>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__item">
                        <form-input label="Adresa" :v="$v" name="form.address"
                                    @change="onChange"
                                    v-model="$v.form.address.$model" length-type="w--xxl"/>
                    </div>
                </div>

                <div class="editor">
                    <br>
                    <label>Popis</label>
                    <formatted-text-editor ref="editor" @change="contentChange"/>
                </div>

            </template>
        </div>

        <div class="elementary-section__controls button-fix">
            <custom-button type="submit" small outline v-bind:class="{'no-updates': !changed}">Uložit</custom-button>
        </div>
    </form>
</template>

<script>
import {maxLength, required, decimal} from 'vuelidate/lib/validators';
import FormattedTextEditor from 'domovio-core/src/components/Editor/FormattedTextEditor';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import FormSelect from 'domovio-core/src/components/Form/Input/FormSelect';
import StatusContainer from '@/modules/ProjectModule/modules/UnitModule/components/Status/StatusContainer';
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import StatusAutocomplete from '@/components/Autocomplete/StatusAutocomplete';

export default {
    name:       'BasicForm',
    components: {
        StatusAutocomplete,
        CustomButton,
        FormCheckbox,
        StatusContainer,
        FormInput,
        FormSelect,
        FormattedTextEditor
    },
    data() {
        return {
            changed: false,
            form:    {
                designation:      null,
                active:           null,
                priceVat:         null,
                statusId:         null,
                priceAlternative: null,
                priceDescription: null,
                proposalType:     'SELL',
                content:          null,
                name:             null,
                address:          null,
            },
        }
    },
    watch:       {
        'form.designation': function (newDesignation) {
            this.$store.dispatch('projects/project/units/unit/setDesignation', newDesignation);
        }
    },
    validations: {
        form: {
            designation:      {required, maxLength: maxLength(20)},
            priceVat:         {required, decimal},
            active:           {},
            priceAlternative: {},
            priceDescription: {},
            proposalType:     {},
            content:          {},
            address:          {},
            name:             {},
            statusId:         {required},
        },
    },
    computed:    {
        designation() {
            return this.$store.getters['projects/project/units/unit/designation'];
        },
        unitData() {
            return this.$store.getters['projects/project/units/unit/unitData'];
        },
        statusId() {
            return this.$store.getters['projects/project/units/unit/statusId'];
        },
        isBroker() {
            return this.$store.getters['projects/project/isBroker'];
        }
    },
    mounted() {
        const {price, active, priceAlternative, priceDescription, proposalType, content, name, address} = this.unitData;
        this.form.designation = this.designation;
        this.form.priceAlternative = priceAlternative || null;
        this.form.priceDescription = priceDescription || null;
        this.form.content = content || null;
        this.form.address = address || null;
        this.form.name = name || null;
        this.form.proposalType = proposalType || 'SELL';
        this.form.active = active || false;
        this.form.priceVat = price ? price.withVat : null;
        this.$refs.status.setSelectedId(this.statusId);
        this.$nextTick(() => this.$refs.editor.setContent(content ? content : ''));
    },
    methods: {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const {
                    designation,
                    priceVat,
                    active,
                    statusId,
                    priceAlternative,
                    priceDescription,
                    proposalType,
                    content,
                    address,
                    name
                } = this.form;
                this.$emit('o3-submit', {
                    designation,
                    active,
                    statusId,
                    priceDescription,
                    proposalType,
                    priceVat: parseFloat(priceVat),
                    priceAlternative,
                    content,
                    address,
                    name
                });
            }
        },
        onChange(e) {
            this.changed = true;
            const {target} = e;
            if (target && target.name === 'form.priceVat') {
                if (this.form.priceVat && this.form.priceAlternative) {
                    this.form.priceAlternative = null;
                }
            }
        },
        contentChange(value) {
            this.changed = true;
            this.form.content = value;
        }
    }
}
</script>
